// Hifi-kleurensysteem voor projecten en contexten.
// Gepoort uit prototype-mui/colorUtils.js — identiek algoritme.

import {
  resolveProjectColorHex,
  resolveProjectColorIndex,
} from '@/utils/projectColorPalette';

// LET OP: moet hex blijven (getTagChipColors parset luma uit deze waarde,
// var() kan hier niet). Houd deze 1-op-1 gelijk aan de --color-context-*
// waarden in src/styles/theme.css — zelfde volgorde, zelfde kleuren.
const CATEGORICAL_CONTEXT_COLORS = [
  '#6B6CA8', // indigo
  '#A85D8C', // fuchsia
  '#D68C3E', // orange
  '#3F8F87', // teal
  '#8A9A4C', // lime
  '#5B8C6E', // emerald
  '#4A7A8C', // cyan
  '#B85C6E', // pink
];

const stringToColor = (str, colorArray) => {
  if (typeof str !== 'string' || !str) return 'transparent';
  const charCodeSum = str
    .split('')
    .reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return colorArray[charCodeSum % colorArray.length];
};

export const isContextTag = (tag) => /^@.+/.test(tag);

export const getContextColor = (contexts) => {
  if (!contexts || contexts.length === 0) return 'transparent';
  const firstContext = Array.isArray(contexts) ? contexts[0] : contexts;
  return stringToColor(firstContext, CATEGORICAL_CONTEXT_COLORS);
};

/**
 * @param {string} projectTagId — lowercase project tag id
 * @param {number | null | undefined} [storedColorIndex]
 */
export const getProjectColor = (projectTagId, storedColorIndex) =>
  resolveProjectColorHex(projectTagId, storedColorIndex);

export const getTagColor = (tag, storedColorIndex) =>
  isContextTag(tag)
    ? getContextColor(tag)
    : getProjectColor(tag, storedColorIndex);

export const getTagChipColors = (tag, storedColorIndex) => {
  const color = getTagColor(tag, storedColorIndex);
  if (color === 'transparent') {
    return { bg: color, text: '#ffffff' };
  }
  const isContext = isContextTag(tag);
  if (!isContext) {
    return { bg: color, text: '#ffffff' };
  }
  const hex = color.replace('#', '');
  const HEX_BLUE_SLICE_END = 6;
  const LUMA_R_WEIGHT = 0.299;
  const LUMA_G_WEIGHT = 0.587;
  const LUMA_B_WEIGHT = 0.114;
  const LUMA_LIGHT_TEXT_THRESHOLD = 170;
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, HEX_BLUE_SLICE_END), 16);
  const luma = LUMA_R_WEIGHT * r + LUMA_G_WEIGHT * g + LUMA_B_WEIGHT * b;
  const text = luma > LUMA_LIGHT_TEXT_THRESHOLD ? '#222222' : '#ffffff';
  return { bg: color, text };
};

export { resolveProjectColorIndex, resolveProjectColorHex };

export const CAPACITY_WARNING_COLOR = 'var(--color-semantic-warning)';

const CAPACITY_WARNING_THRESHOLD = 0.8;

export const getCapacityColor = (planned, max) => {
  const ratio = max > 0 ? planned / max : 0;
  if (ratio >= 1) return 'var(--color-semantic-danger)';
  if (ratio >= CAPACITY_WARNING_THRESHOLD) return CAPACITY_WARNING_COLOR;
  return null;
};
